import { Box } from "@chakra-ui/react";
import React from "react";
import { GrDown, GrUp } from "react-icons/all";
require("./Collapsible.css");
export interface collProps {
  title: string;
  type: string;
}

export interface colState {
  open: boolean;
}
export class Collapsible extends React.Component<collProps, colState> {
  constructor(props: collProps) {
    super(props);
    this.state = {
      open: true,
    };
    this.togglePanel = this.togglePanel.bind(this);
  }

  togglePanel(e: any) {
    this.setState({ open: !this.state.open });
  }

  render() {
    return (
      <Box
        borderRadius={this.props.type !== "subItem" ? "md" : "0px"}
        overflow="hidden"
        boxShadow={"md"}
        className={"collapseTabContainer"}
      >
        <div
          onClick={(e) => this.togglePanel(e)}
          className={"collapseHeader " + this.props.type}
        >
          {this.props.title}{" "}
          {this.state.open ? (
            <GrUp className={"arrow"} onClick={(e) => this.togglePanel(e)} />
          ) : (
            <GrDown className={"arrow"} onClick={(e) => this.togglePanel(e)} />
          )}
        </div>
        {this.state.open ? (
          <div className={"content " + this.props.type}>
            {this.props.children}
          </div>
        ) : null}
      </Box>
    );
  }
}
